import DateUtil from 'client/util/DateUtil';
import LocalStorageConstants from 'client/util/Constants/LocalStorageConstants';

const UXRSurveyBannerConfig = (user = {}) => ({
  name: 'UXRSurveyBanner',
  bannerText: 'Your insights and feedback help us build the platform you want and need. To make your opinions and ideas known, follow the link below to our bi-annual user experience survey, and be entered to win 1 of 3 $50 gift cards!',
  learnMoreLink: 'https://www.surveymonkey.com/r/FDVKWTP',
  learnMoreText: 'Please take this brief survey',
  startDate: '2023/03/13',
  endDate: '2023/03/19',
  localStorageKey: LocalStorageConstants.bannerDismissedUXRSurvey,
  bannerVisibility: () => !user.isCommandRunner
  && user.isCustomer
  && (DateUtil.daysAfter(user.orgCreatedDate) > 90),
});

export default UXRSurveyBannerConfig;
